import React from "react";
import { Spin, UploadProps } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { SvgIcons } from "Icon/SvgIcons";

interface UploadFileProps extends UploadProps {
  primaryText?: string;
  secText?: string;
  isLoading?: boolean;
  className?: string;
  isPadding?: boolean;
}

const UploadFile: React.FC<UploadFileProps> = ({
  primaryText = "Click to upload",
  secText = "Csv (max. 1Mb)",
  className,
  isPadding = true,
  isLoading,
  ...props
}) => {
  return (
    <div className={`${isPadding ? "pb-4" : ""} w-full`}>
      <Dragger
        {...props}
        className={`bg-white hover:border-border-theme border-solid ${className}`}
        style={{
          borderStyle: "solid",
          background: 'white',
        }}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon mx-auto text-center">
          {isLoading ? <Spin /> : <span className="w-max inline-flex">{SvgIcons.uploadSvg}</span>}
        </p>
        <p className="text-text-tertiary text-sm">
          <strong className="text-primary font-semibold">{primaryText}</strong> or drag and drop
        </p>
        <p className="text-text-tertiary text-sm font-normal">{secText}</p>
      </Dragger>
    </div>
  );
};

export default UploadFile;
